<div class="row">
    <div class="col-12">
        <h3>Edytuj:</h3>
        <app-rekbot-form [rekbotId]="elementId"></app-rekbot-form>
    </div>
</div>   